module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><polygon points=\"0 17.9 2.43 15.5 10.19 23.19 29.57 4 32 6.41 10.19 28\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/check-thin.svg
// module id = 842
// module chunks = 0